import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import NumericInput from '@/components/v2/NumericInput.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import LoadingOverlay from '@/components/v2/LoadingOverlay.vue';
import { required, numeric } from 'vuelidate/lib/validators';
import { Getter } from 'vuex-class';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import ActiveCampaign from '@/components/v2/survey/ActiveCampaign';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let CampaignRaffleForm = class CampaignRaffleForm extends mixins(FormMixin, FormValidationsMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.date = null;
        this.form = {
            name: null,
            description: null,
            prize: null,
            campaignUuid: null,
            taskUuid: null,
            winnerCount: null,
            repeatWinner: false,
        };
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.$emit('submit', this.form);
        }
    }
};
__decorate([
    Getter('requestOnFlight')
], CampaignRaffleForm.prototype, "mutationRequestOnFlight", void 0);
CampaignRaffleForm = __decorate([
    Component({
        components: {
            ActionButton,
            FormHeader,
            NumericInput,
            BaseTextField,
            ActiveCampaign,
            LoadingOverlay,
        },
        validations: {
            form: {
                name: {
                    required,
                },
                prize: {
                    required,
                },
                campaignUuid: {
                    required,
                },
                winnerCount: {
                    numeric,
                    required,
                },
            },
        },
    })
], CampaignRaffleForm);
export default CampaignRaffleForm;
